/**
 * Function that does nothing.
 */
export function noop() {}
